// ============================================================================
// Cosa propongono le finestre di scelta file degli allegati (media) e del
// catalogo. Rispecchia il contratto del backend, `backend/src/utils/tipoFile.ts`
// (MIME_FOTO_VIDEO, più il PDF per il catalogo): un tipo che il backend
// rifiuta non deve essere selezionabile, altrimenti l'errore arriva solo dopo
// un upload che può pesare fino a 100 MB.
//
// Tre scostamenti voluti dal backend:
// - HEIC/HEIF NON sono in elenco, anche se il backend li accetta. Se il
//   frontend li chiede, l'iPhone li manda così come sono invece di convertirli
//   in JPEG, e un HEIC non si vede nelle anteprime di Chrome, Edge e Firefox né
//   finisce nel PDF del sopralluogo (`backend/src/pdf/miniature.ts` lo salta).
//   Su Android un'estensione che il telefono non conosce diventa
//   `application/octet-stream` e toglie la fotocamera diretta.
// - `image/jpeg` va PER PRIMO: WebKit converte un HEIC verso il primo tipo
//   dell'elenco (https://bugs.webkit.org/show_bug.cgi?id=292041). Per lo
//   stesso motivo nel catalogo il PDF sta in coda.
// - `image/jpg`, l'alias che il backend accetta per i browser che lo mandano,
//   qui non serve: lo stesso file lo coprono `image/jpeg` e `.jpg`.
//
// Le estensioni accanto ai MIME servono ai selettori dei sistemi desktop che
// filtrano per estensione.
// ============================================================================

/** Solo foto: è anche il valore che accende `capture` nelle categorie dei sopralluoghi. */
export const ACCEPT_FOTO = "image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif";

/** Foto o video: gli allegati di interventi, installazioni, attivazioni, clienti. */
export const ACCEPT_FOTO_VIDEO = `${ACCEPT_FOTO},video/mp4,video/quicktime,video/webm,.mp4,.mov,.webm`;

/** Documenti del catalogo: foto, video e PDF. */
export const ACCEPT_CATALOGO = `${ACCEPT_FOTO_VIDEO},application/pdf,.pdf`;
